import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Fab, Action } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import AddClient from "../Invoice/AddClient";
import AddProduct from "../Products/AddProduct";
import AddAssistant from "../assistants/AddAssistant";

const FabButton = () => {
  const location = useLocation();
  const mainButtonStyles = { backgroundColor: "#1976D2" };
  const [open, setOpen] = useState(false);
  const [openProd, setOpenProd] = useState(false);
  const [openAssistant, setOpenAssistant] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);
  // if(location.pathname === '/invoice') return null

  return (
    <div>
      <AddProduct setOpen={setOpenProd} open={openProd} />
      <AddClient setOpen={setOpen} open={open} />
      <AddAssistant setOpen={setOpenAssistant} open={openAssistant} />
      <Fab
        mainButtonStyles={mainButtonStyles}
        icon={<AddIcon />}
        alwaysShowTitle={true}
      >
        {location.pathname !== "/invoice" && (
          <Action
            text="New Invoice"
            // onClick={() =>  history.push(`/invoice`)}
            onClick={() => (window.location.href = "/invoice")}
          >
            <CreateIcon />
          </Action>
        )}

        <Action text="New Customer" onClick={() => setOpen((prev) => !prev)}>
          <PersonAddIcon />
        </Action>
        {user.result.role !== "assistant" && (
          <Action
            text="New Product"
            onClick={() => setOpenProd((prev) => !prev)}
          >
            <PersonAddIcon />
          </Action>
        )}
        {user.result.role !== "assistant" && (
          <Action
            text="New Assistant"
            onClick={() => setOpenAssistant((prev) => !prev)}
          >
            <PersonAddIcon />
          </Action>
        )}
      </Fab>
    </div>
  );
};

export default FabButton;
